export const userProfileTranslations = {
  menu_text: 8212,
  notifications_text: 8213,
  settings_text: 8214,
  default_values_text: 8215,
  subscriptions: 8781,
  no_content: 8239
};

export type UserProfileTranslation = {
  readonly [T in keyof typeof userProfileTranslations]: string
};
